module.exports = __webpack_public_path__ + "media/images/icons/icon-snapchat-940b1a7f37c2c30400a3a312c566b9ab.svg";